/**
 * @copyright
 * Copyright (c) 2025 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { ComplianceDetailsFromApi, ComplianceReviewDetails, ComplianceReviewStatus } from "~/features/myAccount/types";

const transformToComplianceReview = (reviewData: Partial<ComplianceDetailsFromApi>): ComplianceReviewDetails => {
  return {
    status: reviewData.reviewStatus ?? ComplianceReviewStatus.UNKNOWN,
    reviewedAt: reviewData.reviewedAt ?? "",
    note: reviewData.note ?? "",
    reviewId: reviewData.id ?? 0,
  };
};

export default transformToComplianceReview;
